import { b as c, r as s, f as u } from "./export-cdcbfb2b.js";
import { t as v } from "./to-string-92a62764.js";
var f = c, l = s, i = v, p = /"/g, m = f("".replace), h = function(e, r, t, o) {
  var n = i(l(e)), a = "<" + r;
  return t !== "" && (a += " " + t + '="' + m(i(o), p, "&quot;") + '"'), a + ">" + n + "</" + r + ">";
}, b = u, C = function(e) {
  return b(function() {
    var r = ""[e]('"');
    return r !== r.toLowerCase() || r.split('"').length > 3;
  });
};
export {
  h as c,
  C as s
};
